import modalStyle from "../styles/modal.module.scss";
import { editIcon, closeIcon } from "./Icons";

function MaterialDetailLayout({
  materialData,
  ROOT_SERVER,
  viewing,
  imageNumber,
  onChangeImage,
  imageLoaded,
  onImageLoaded,
  onClose,
  closeLabel = "close",
  onEdit,
  canEdit,
  editLabel,
  editMeta,
  onPrimaryAction,
  primaryLabel,
  onSecondaryAction,
  secondaryLabel,
  secondaryLoadingLabel,
  secondaryIsLoading,
  brandData,
  showBrandData,
  mode = "modal",
  containerRef,
  onContainerClick,
  imagePaneStyle,
  dataPaneStyle,
}) {
  if (!materialData) {
    return null;
  }

  const {
    title,
    slug,
    description,
    price,
    status,
    type,
    subtype,
    images,
    substrate,
    vendor,
    character,
    feature,
  } = materialData;

  const materialImages = Array.isArray(images) ? images : [];
  const characterList = Array.isArray(character) ? character : [];
  const featureList = Array.isArray(feature) ? feature : [];
  const isPageMode = mode === "page";

  const sustainablityData = {
    title: "sustainability",
    info: [
      "Asiatan Kind Leather",
      "Carbon Neutral Athletic Leather",
      "Common Crust Program",
      "90% Cutting Value for Reduced waste",
    ],
  };
  const splitData = {
    title: "Fashion Suede",
    info: ["Split based fashion leather"],
  };
  const tectuffData = {
    title: "tectuff features",
    info: [
      "durable performance finish",
      "abrasion resistant",
      "water-based PU finish",
    ],
  };

  const renderInfoBox = () => {
    const infoSource =
      type === "split" && vendor === "tectuff"
        ? tectuffData
        : type === "split"
          ? splitData
          : sustainablityData;

    return (
      <div className={modalStyle.infoBox}>
        <div style={{ width: "100%" }} className={modalStyle.infoContent}>
          <div className={modalStyle.infoContentHeader}>
            <h4>{infoSource.title}</h4>
          </div>
          <div className={modalStyle.infoContentBody}>
            {infoSource.info.map((item) => (
              <h4 key={item}>{item}</h4>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      className={`${modalStyle.materialModal} ${
        isPageMode ? modalStyle.pageMaterialModal : ""
      }`}
      onClick={onContainerClick}
      ref={containerRef}
    >
      <div
        className={`${modalStyle.modalContent} ${
          isPageMode ? modalStyle.pageModalContent : ""
        }`}
      >
        <div
          className={`${modalStyle.imageContainer} ${
            isPageMode ? modalStyle.pageImageContainer : ""
          }`}
          style={imagePaneStyle}
        >
          {!imageLoaded && (
            <div className={modalStyle.imageStateOverlay} aria-hidden="true">
              <div className={modalStyle.imageLoaderDots}>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          )}
          <img
            className={modalStyle.materialImage}
            src={viewing}
            alt={`${vendor} - ${title}`}
            onLoad={onImageLoaded}
            style={
              imageLoaded ? { filter: "blur(0px)" } : { filter: "blur(6px)" }
            }
          />
          <div
            className={`${modalStyle.imageSelector} ${
              isPageMode ? modalStyle.pageImageSelector : ""
            }`}
          >
            {materialImages.length >= 2 &&
              materialImages.map((image, i) => (
                <div
                  key={`${image} -- ${i}`}
                  data-image={`${image} -- ${i}`}
                  className={`${modalStyle.swatch} ${
                    i === imageNumber ? modalStyle.active : ""
                  }`}
                  style={{ overflow: "hidden" }}
                  onClick={() => onChangeImage(i)}
                >
                  <img
                    src={`${ROOT_SERVER}${vendor}/${slug}/thumbnail/${image}`}
                    alt={slug + i}
                  />
                </div>
              ))}
          </div>
        </div>

        <div
          className={`${modalStyle.dataContainer} ${
            isPageMode ? modalStyle.pageDataContainer : ""
          }`}
          style={dataPaneStyle}
        >
          {!isPageMode && (
            <div className={modalStyle.closeButton} onClick={onClose}>
              <span>{closeLabel}</span> {closeIcon}
            </div>
          )}
          <div
            className={`${modalStyle.dataContainerTop} ${
              isPageMode ? modalStyle.pageDataContainerTop : ""
            }`}
          >
            <h3 style={{ textTransform: "uppercase" }}>{vendor}</h3>
            <h1>{title}</h1>
            <h3>{description}</h3>

            <div className={modalStyle.infoBox}>
              <div className={modalStyle.infoContent}>
                <div className={modalStyle.infoContentHeader}>
                  <h4>Price</h4>
                </div>
                <div className={modalStyle.infoContentBody}>
                  <div className={modalStyle.price}>
                    <div className={modalStyle.value}>
                      ${Number(price || 0).toFixed(2)}
                    </div>
                    <div className={modalStyle.uom}>/ sq.ft.</div>
                    <span className={modalStyle.disclaimer}>
                      Price for reference only.
                    </span>
                  </div>
                </div>
              </div>
              <div className={modalStyle.infoContent}>
                <div className={modalStyle.infoContentHeader}>
                  <h4>Material Data</h4>
                </div>
                <div className={modalStyle.infoContentBody}>
                  <h6>Type: {substrate}</h6>
                  <h6>Subtype: {type}</h6>
                  <h6>Group: {subtype}</h6>
                  <h6>Status: {status}</h6>
                </div>
              </div>
            </div>

            <div className={modalStyle.infoBox}>
              <div className={modalStyle.infoContent}>
                <div className={modalStyle.infoContentHeader}>
                  <h4>CHARACTER</h4>
                </div>
                <div className={modalStyle.infoContentBody}>
                  <h4>{characterList[0] || "--"} temper</h4>
                  <h4>{characterList[1] || "--"}</h4>
                </div>
              </div>
              <div className={modalStyle.infoContent}>
                <div className={modalStyle.infoContentHeader}>
                  <h4>Finish</h4>
                </div>
                <div className={modalStyle.infoContentBody}>
                  {featureList.map((fin, i) => (
                    <h4 key={fin + i}>{fin}</h4>
                  ))}
                </div>
              </div>
            </div>

            {renderInfoBox()}

            {showBrandData &&
              Array.isArray(brandData) &&
              brandData.length > 0 && (
                <div className={modalStyle.infoBox}>
                  <div
                    style={{ width: "100%" }}
                    className={modalStyle.infoContent}
                  >
                    <div className={modalStyle.infoContentHeader}>
                      <h4>Nike Data</h4>
                    </div>
                    <div className={modalStyle.infoContentBody}>
                      {brandData.map((data, i) => (
                        <h4 key={data.pcx_material_number + i}>
                          {title} - {data.thickness}mm - PCX#:
                          {data.pcx_material_number}
                        </h4>
                      ))}
                    </div>
                  </div>
                </div>
              )}

            {canEdit && (
              <div className={modalStyle.infoBox}>
                <div className={modalStyle.infoContent}>
                  <div
                    className={`${modalStyle.infoContentBody} ${modalStyle.editButton}`}
                    onClick={onEdit}
                  >
                    {editIcon}
                    <h4 className={modalStyle.pageLink}>
                      {editLabel || `Edit ${title}`}
                    </h4>
                    {editMeta ? <h4>{editMeta}</h4> : null}
                  </div>
                </div>
              </div>
            )}
          </div>

          <div
            className={`${modalStyle.dataContainerBottom} ${
              isPageMode ? modalStyle.pageDataContainerBottom : ""
            }`}
          >
            <div
              className={`${modalStyle.bottomButton} ${
                !onPrimaryAction ? modalStyle.actionDisabled : ""
              }`}
              onClick={onPrimaryAction}
            >
              <h4>{primaryLabel}</h4>
            </div>
            {!secondaryIsLoading ? (
              <div
                className={`${modalStyle.bottomButton} ${
                  !onSecondaryAction ? modalStyle.actionDisabled : ""
                }`}
                onClick={onSecondaryAction}
              >
                <h4>{secondaryLabel}</h4>
              </div>
            ) : (
              <div className={modalStyle.bottomButton}>
                <h4>{secondaryLoadingLabel || "Loading"}</h4>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MaterialDetailLayout;
